import React from 'react';

import {
  FlowchartActionFunction,
  FlowchartActionItem,
  FlowchartBase,
} from 'processes/graph-builder/flowchart-viz/FlowchartVizConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export interface FlowchartActionFunctionButtonProps<
  TItem extends FlowchartActionItem,
  TFlowchart extends FlowchartBase,
> {
  actionFunction: FlowchartActionFunction<TItem, TFlowchart>;
  item: TItem;
  setIsActionFunctionToolbarVisible: (isVisible: boolean) => void;
}

export default function FlowchartActionFunctionButton<
  TItem extends FlowchartActionItem,
  TFlowchart extends FlowchartBase,
>({
  actionFunction,
  item,
  setIsActionFunctionToolbarVisible,
}: FlowchartActionFunctionButtonProps<TItem, TFlowchart>): JSX.Element {
  const {icon, name, tooltipText, flowchart, updateHandler, getIsDisabled, onInvoke} = actionFunction;
  return (
    <Tooltip title={tooltipText}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        disabled={getIsDisabled != null ? getIsDisabled(item, flowchart) : false}
        icon={icon}
        onClick={() => {
          setIsActionFunctionToolbarVisible(false);
          onInvoke({
            item,
            flowchart,
            updateHandler: (flowchart) => {
              updateHandler(flowchart);
              setIsActionFunctionToolbarVisible(true);
            },
          });
        }}
        size={ButtonSize.MINI}
        dataTestAttrs={{component: 'FlowchartActionFunctionButton', element: 'root', key: name}}
      />
    </Tooltip>
  );
}
